var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 65,
    viewBox: "0 0 55 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.211 47.452C-2.422 36.82-2.422 19.58 8.211 8.947c10.633-10.633 27.872-10.633 38.505 0 10.633 10.633 10.633 27.872 0 38.505L31.827 62.341a6.172 6.172 0 01-8.727 0L8.21 47.452z",
    fill: "#32A3F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.425,
    cy: 28.202,
    r: 11.798,
    transform: "rotate(-90 27.425 28.202)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPin);
export default __webpack_public_path__ + "static/media/selected-pin.2983a89c.svg";
export { ForwardRef as ReactComponent };